import { post, get, put, deleteApi } from './axiosFun';

// 消息列表
export const messageList = () => { return post("/msg/message/list", {}) };
// 消息分页
export const messagePage = (params) => { return post("/msg/message/page", params) };
// 消息详情
export const messageDetails = (id) => { return get(`/msg/message/detail/${id}`) };



// WEBPACK FOOTER //
// ./src/api/message.js